import SideMenu from "./sideMenu.js";

export default SideMenu;
